import { updateObject } from '../../helpers/utility.helper';
import { initialState } from '../state/auth.state';
import authType from '../types/auth.type';
import IAuthState from '../models/IAuthState';


const loginStart = (oldState: IAuthState, action: any) => {
    return updateObject(oldState, { error: null, loading: true });
};

const loginSuccess = (oldState: IAuthState, action: any) => {

    return updateObject(oldState, {
        token: action.payload.AuthToken,
        userId: action.payload.UserId,
        userName: action.payload.UserName,
        userType: action.payload.UserType,
        error: null,
        loading: false
    });
};

const loginFailed = (oldState: IAuthState, action: any) => {
    return updateObject(oldState, {
        error: action.payload,
        loading: false
    });
};

const loginLogged = (oldState: IAuthState, action: any) => {
    return updateObject(oldState, {
        error: action.payload,
        logged: true,
        loading: false
    });
};

const logoutSuccess = (oldState: any, action: any) => {
    return updateObject(oldState, {
        token: ''
    });
};

const authReducer = (oldState: IAuthState = initialState, action: any) => {
    switch (action.type) {
        case authType.LOGIN_START: return loginStart(oldState, action);
        case authType.LOGIN_SUCCESS: return loginSuccess(oldState, action);
        case authType.LOGIN_LOGGED: return loginLogged(oldState, action);
        case authType.LOGIN_FAILED: return loginFailed(oldState, action);
        case authType.LOGOUT_SUCCESS: return logoutSuccess(oldState, action);
        case authType.UPDATE_AUTH: return loginSuccess(oldState, action);
        default: return oldState;
    }
};
export default authReducer;